//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomNumberInput from '@/components/common/custom-number-input'
import ProductSwiper from '@/frontend/components/common/product-swiper'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import {mapActions, mapState, mapMutations} from 'vuex'
import ShoppingCartDeleteDialog from '@/frontend/components/common/shopping-cart-delete-dialog.vue'
import {attributeTypeCodes} from "@/enums/customAttributeTypeCodes";
import {attributesMixin} from "@/mixins/attributesMixin";
export default {
  name: 'ShoppingCart',
  components: {
    ProductSwiper,
    CustomNumberInput,
    ShoppingCartDeleteDialog,
  },
  mixins: [columnFormatterMixin, attributesMixin],
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      newProducts: undefined,
      additionalInfo: '',
      confirmationDialogVisibility: false,
      cartLoading: true,
      productCategory: ''
    }
  },
  computed: {
    ...mapState('shoppingCart', [
      'cartItems',
      'cartItemCount',
      'salesTax',
      'shippingPrice',
      'subTotal',
      'grandTotal',
    ]),
    cartItemsWithAttributes() {
      return this.cartItems.map((item) => {
        return {
          ...item,
          attributes: item.itemTypeData?.attributes
            .map((attribute) => {
            let value = attribute.value
            if(attribute.attributeTypeCode === attributeTypeCodes.LIST) {
              const options = this.buildOptionsForListAttribute(attribute)
              const currentlySelected = options.find((o) => o.value === parseInt(attribute.value))
              value = currentlySelected ? currentlySelected.text : ''
            }
            return {
              ...attribute,
              value: attribute.value
                ? value
                : attribute.valueText,
            }
          }),
        }
      })
    },
  },
  watch: {
    cartItems: {
      handler(val) {
        this.updateSubTotal()
        this.updateGrandTotal()
      },
      deep: true,
    },
  },
  async mounted() {
    this.cartLoading = true
    await this.frontendGetBySessionId()
    await this.getNewProducts()
    this.cartLoading = false
  },
  methods: {
    ...mapMutations('shoppingCart', [
      'updateSubTotal',
      'updateGrandTotal',
      'setAdditionalInfo',
    ]),
    ...mapActions('shoppingCart', [
      'frontendGetBySessionId',
      'updateQuantityFrontend',
      'deleteCartItemFrontend',
    ]),
    ...mapActions('backoffice/products', ['fetchRetailProducts']),
    getNewProducts() {
      this.fetchRetailProducts({
        filters: {
          pageSize: 4,
          pageNo: 1,
        },
      })
        .then((response) => {
          this.newProducts = response.map((item) => {
            return {
              name: item.name,
              image: item.imageUrl,
              link: `/product/${item.code}`,
            }
          })
        })
        .catch(() => {
          this.$toast.error('Error while fetching new products')
        })
    },
    async updateCartItemQuantity({id, quantity}) {
      this.isLoading = true
      try {
        await this.updateQuantityFrontend({id, quantity})
      } finally {
        this.isLoading = false
      }
    },
    async deleteCartItem() {
      this.isLoading = true
      try {
        if (this.currentItemID) {
          await this.deleteCartItemFrontend(this.currentItemID)
        }
      } finally {
        this.isLoading = false
        this.currentItemID = undefined
        this.closeDialog()
      }
    },
    closeDialog() {
      this.confirmationDialogVisibility = false
      this.currentItemID = undefined
    },
    deleteCartItemDialog(itemID) {
      this.confirmationDialogVisibility = true
      this.currentItemID = itemID
    },
    continueShopping() {
      this.$router.push('catalog')
    },
    checkout() {
      this.setAdditionalInfo({
        notes: this.additionalInfo,
      })
      this.$router.push('checkout')
    },
    async editCartItem(productCode, itemId) {
        await this.$axios.get(
          '/ProductCategories/categorybysku/' +
          productCode
        ).then((category) => {
          if (!category.data.hasErrors){
            this.productCategory = category.data.value?.code
          }
        })
      await this.$router.push(`/product-detail/${productCode}?categoryCode=${this.productCategory}&cartItemId=${itemId}`)
    },
  },
}
